import BaseModel from '../../../api/models/BaseModel';

class LogoutResponseModel extends BaseModel {
  constructor(arg: any) {
    super(arg);
  }
}

export default LogoutResponseModel;
